<!-- 
create by melody on 2018/11/1 
description:角色管理页面 
-->
<template>
    <div>
        <page-header :title="title"></page-header>
        <template v-if="showModify==false">
            <div class="search-container">
                <el-form label-width="100px">
                    <el-row>
                        <el-col :xl="8" :lg="10" :md="12">
                            <el-form-item :label="$t('m.roleName')" style="width: 400px;">
                                <el-input v-model="searchParam.name" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="8"  :lg="10"  :md="12">
                            <el-form-item :label="$t('m.roleCode')" style="width: 400px;">
                                <el-input v-model="searchParam.code" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="8"  :lg="10"  :md="12">
                            <el-form-item :label="$t('m.enableFlag')" style="width: 400px;">
                                <el-select v-model="searchParam.enableFlag" clearable>
                                    <el-option
                                        :label="$t('m.enable')"
                                        :value="true">
                                    </el-option>
                                    <el-option
                                        :label="$t('m.disable')"
                                        :value="false">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item style="width: 400px;">
                        <lap-search-btn :searchParam="searchParam" @successMethod="getRoleList()"></lap-search-btn>
                        <!-- <el-button type="primary" icon="el-icon-search" @click="getRoleList()"> 查 询 </el-button> -->
                    </el-form-item>
                </el-form>
            </div>
            <div class="table-container">
                <el-button type="primary" plain icon="el-icon-plus" @click="handleClick('add')"> {{$t('m.add')}} </el-button>
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    stripe
                    tooltip-effect="dark"
                    style="width: 100%;margin: 24px 0"
                    >
                    <el-table-column
                        type="index"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        prop="roleCode"
                        :label="$t('m.roleCode')"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        :label="$t('m.roleName')"
                        prop="roleName"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="createBy"
                        :label="$t('m.createBy')"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        :label="$t('m.createTime')"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        prop="updateBy"
                        :label="$t('m.updateBy')"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="updateTime"
                        :label="$t('m.updateTime')"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        prop="enableFlag"
                        :label="$t('m.enableFlag')"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.enableFlag == true ? $t('m.enable') : $t('m.disable')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column 
                        fixed="right"
                        width="150" 
                        :label="$t('m.operation')">
                        <template slot-scope="scope">
                            <el-button
                                icon="el-icon-edit-outline" 
                                plain
                                size="mini"
                                @click="handleClick('modify', scope.row)"></el-button>
                            <!-- <el-button
                                icon="el-icon-delete"
                                plain
                                size="mini"
                                type="danger"
                                @click="handleDelete('single',scope.row)"></el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <lap-pagination :total="total" :searchParam="searchParam" @successMethod="getRoleList()"></lap-pagination>
            </div>
        </template>
        <template v-if="showModify==true">
            <el-button style="margin-bottom: 10px" type="primary" size="small" icon="el-icon-back" @click="showModify = false">{{$t('m.back')}}</el-button>
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('m.roleInfo')">
                    <div class="dialog-content" style="margin-top: 50px">    
                        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                            <el-form-item :label="$t('m.roleName')" prop="name" style="width: 100%">
                                <el-input v-model="form.name" clearable></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('m.enableFlag')" prop="enableFlag" style="width: 100%;">
                                <el-radio-group  v-model="form.enableFlag">
                                    <el-radio :label="true" checked>{{$t('m.enable')}}</el-radio>
                                    <el-radio :label="false">{{$t('m.disable')}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item style="width: 400px">
                                <el-button type="primary" @click="haddleSave('modify')">{{$t('m.save')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('m.relatedUsers')">
                    <div class="search-container">
                        <el-form label-width="100px">
                            <el-row>
                                <el-col :xl="8" :lg="10" :md="12">
                                    <el-form-item :label="$t('m.userName')" style="width: 400px;">
                                        <el-input v-model="searchParam2.name" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xl="8"  :lg="10"  :md="12">
                                    <el-form-item :label="$t('m.enableFlag')" style="width: 400px;">
                                        <el-select v-model="searchParam2.enableFlag" clearable>
                                            <el-option
                                                :label="$t('m.enable')"
                                                :value="true">
                                            </el-option>
                                            <el-option
                                                :label="$t('m.disable')"
                                                :value="false">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item style="width: 400px;">
                                <!-- <el-button type="primary" icon="el-icon-search" @click="getRoleUser()"> 查 询 </el-button> -->
                                <lap-search-btn :searchParam="searchParam2" @successMethod="getRoleUser()"></lap-search-btn>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="table-container">
                        <el-button type="primary" plain icon="el-icon-plus" @click="handleChoose()"> {{$t('m.choose')}} </el-button>
                        <el-button type="info" plain icon="el-icon-delete" @click="handleDelete2('batch')"> {{$t('m.delete')}} </el-button>
                        <el-table
                            ref="multipleTable"
                            :data="tableData2"
                            stripe
                            tooltip-effect="dark"
                            style="width: 100%;margin: 24px 0"
                            @select="handleSelect2" 
                            @select-all="handleSelect2"
                            >
                            <el-table-column
                                type="selection"
                                width="55">
                            </el-table-column>
                            <el-table-column
                                type="index"
                                width="55">
                            </el-table-column>
                            <el-table-column
                                :label="$t('m.userName')"
                                prop="userName"
                                width="120">
                            </el-table-column>
                            <el-table-column
                                prop="userMobile"
                                :label="$t('m.mobile')"
                                width="200">
                            </el-table-column>
                            <el-table-column
                                prop="userEmail"
                                :label="$t('m.email')"
                                width="200">
                            </el-table-column>
                            <!-- <el-table-column
                                prop="orgName"
                                label="组织名称"
                                width="150">
                            </el-table-column> -->
                            <el-table-column
                                prop="userStartDate"
                                :label="$t('m.startDate')"
                                width="120">
                            </el-table-column>
                            <el-table-column
                                prop="userEndDate"
                                :label="$t('m.endDate')"
                                width="120">
                            </el-table-column>
                            <el-table-column
                                prop="enableFlag"
                                :label="$t('m.enableFlag')"
                                show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{scope.row.enableFlag == true ? $t('m.enable') : $t('m.disable')}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('m.operation')">
                                <template slot-scope="scope">
                                    <el-button
                                        icon="el-icon-delete"
                                        plain
                                        size="mini"
                                        type="danger"
                                        @click="handleDelete2('single',scope.row)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <lap-pagination :total="total2" :searchParam="searchParam2" @successMethod="getRoleUser()"></lap-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('m.relatedResources')">
                    <el-tree
                        ref="tree"
                        :data="treeData"
                        show-checkbox
                        node-key="menuId"

                        default-expand-all
                        :check-strictly="checkStrictly"  
                        :default-checked-keys="defaultCheckedMenu"
                        :props="defaultProps">
                    </el-tree>
                    <!-- 右击弹出按钮选择弹框 -->
                    <!-- @node-contextmenu="clickNode" -->
                    <el-button style="margin:20px" type="primary" @click="addRoleMenu()">{{$t('m.save')}}</el-button>
                </el-tab-pane>
            </el-tabs>
        </template>
        <el-dialog
            :title="operateType=='add'? $t('m.add') :operateType=='modify'? $t('m.modify') :''"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="dialog-content">
                <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item :label="$t('m.roleName')" prop="name" style="width: 400px">
                        <el-input v-model.trim="form.name" :maxlength="15"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.enableFlag')" prop="enableFlag" style="width: 400px;">
                        <el-radio-group  v-model="form.enableFlag">
                            <el-radio :label="true" checked> {{$t('m.enable')}} </el-radio>
                            <el-radio :label="false"> {{$t('m.disable')}} </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span v-if="operateType!='view'" slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="$t('m.choose')"
            v-if="chooseDialogVisible"
            :visible.sync="chooseDialogVisible"
            width="70%">
            <div>
                <el-form label-width="100px">
                    <el-row>
                        <el-col :xl="8" :lg="10" :md="12">
                            <el-form-item :label="$t('m.userName')" style="width: 400px;">
                                <el-input v-model.trim="searchParam3.name" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="8"  :lg="10"  :md="12">
                            <el-form-item :label="$t('m.enableFlag')" style="width: 400px;">
                                <el-select v-model="searchParam3.enableFlag" clearable>
                                    <el-option
                                        :label="$t('m.enable')"
                                        :value="true">
                                    </el-option>
                                    <el-option
                                        :label="$t('m.disable')"
                                        :value="false">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item style="width: 400px;">
                        <!-- <el-button type="primary" icon="el-icon-search" @click="getRoleNoUser()"> 查 询 </el-button> -->
                        <lap-search-btn :searchParam="searchParam3" @successMethod="getRoleNoUser()"></lap-search-btn>
                    </el-form-item>
                </el-form>
                <el-table
                    ref="multipleTable"
                    :data="tableData3"
                    stripe
                    tooltip-effect="dark"
                    style="width: 100%;margin: 24px 0"
                    @select="handleSelect3" 
                    @select-all="handleSelect3"
                    >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        type="index"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        :label="$t('m.userName')"
                        prop="userName">
                    </el-table-column>
                    <el-table-column
                        prop="userMobile"
                        :label="$t('m.mobile')">
                    </el-table-column>
                    <el-table-column
                        prop="userEmail"
                        :label="$t('m.email')">                    
                    </el-table-column>
                    <!-- <el-table-column
                        prop="orgName"
                        label="组织名称">
                    </el-table-column> -->
                    <el-table-column
                        prop="enableFlag"
                        :label="$t('m.enableFlag')"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.enableFlag == true ? $t('m.enable') : $t('m.disable')}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <lap-pagination :total="total3" :searchParam="searchParam3" @successMethod="getRoleNoUser()"></lap-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="chooseDialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" @click="handleBatchAddRoleUser()">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="$t('m.chooseBtn')"
            v-if="buttonDialogVisible"
            :visible.sync="buttonDialogVisible"
            width="960px">
            <div style="padding: 30px">
                <el-checkbox v-model="checkAll" @change="handleCheckAllChange" border>{{$t('m.chooseAll')}}</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="checkedButtons"  @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="(item,index) in buttons" :label="item.value" :key="index" border>{{item.label}}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="buttonDialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" @click="modifyRoleMenuButton()">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            checkStrictly: true, //tree组件属性
            checkAll: false,
            checkedButtons: [],
            buttons: [],
            title:{
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.SYSTEM_MANAGE'),
                thirdTitle: this.$t('m.ROLE_MANAGE')
            },
            roleIdFlag: '', //修改的当前用户
            menuIdFlag: '', //修改当前菜单
            searchParam: {      //查询角色参数
                name: '',
                code: '',
                enableFlag: '',
                pageSize: 10,
                pageNum: 1,
            },
            searchParam2: {      //查询拥有用户参数
                roleId: this.roleIdFlag,
                name: '',
                enableFlag: '',
                pageSize: 10,
                pageNum: 1,
            },
            searchParam3: {      //查询未拥有用户参数
                roleId: this.roleIdFlag,
                name: '',
                enableFlag: '',
                pageSize: 10,
                pageNum: 1,
            },
            form: {     //弹框内容
                roleId: '',
                name: '',
                enableFlag: true
            },
            rules: this.$ruleApi.getRule('role'),
            tableData: [],  //角色表数据
            tableData2: [], //拥有用户
            tableData3: [], //未拥有用户
            total: 0,   //总数
            total2: 0,   //拥有用户总数
            total3: 0,   //未拥有用户总数
            dialogVisible: false,   //控制弹框显示与隐藏
            chooseDialogVisible: false,//选择用户弹框
            roleList: [],   //选择角色列表
            operateType: '',    //操作类型 add新增 modify修改 view查看
            userIdArr2: [],  //批量删除拥有用户数组
            userIdArr3: [],  //批量删除未拥有用户数组
            showModify: false,
            treeData: [],
            defaultProps: {
                children: 'childrenList',
                label: 'menuName',
                menuId:'menuId'
            },
            defaultCheckedMenu: [],
            buttonDialogVisible: false,
            addDisable: false
        }
    },
    methods: {
        handleCheckAllChange(val) {
            if(val) {
                let arr = []
                this.buttons.forEach( (o,i)=> {
                    arr.push(o.value)
                })
                this.checkedButtons = arr
            } else {
                this.checkedButtons = [];
            }
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.buttons.length;
        },
        //右击给角色菜单添加按钮
        clickNode(event,data) {
            let hasChechedMenuId = false 
            this.$refs.tree.getCheckedNodes().forEach(function(item,index){
                if(item.menuId == data.menuId) {
                    hasChechedMenuId = true
                }
            })
            //点击的菜单未被勾选
            if(!hasChechedMenuId) {
                this.$message.info(this.$t('m.chooseMenu'))
                return
            }
            //点击叶子节点弹出按钮选择弹框
            if(!data.childrenList) {
                this.buttons = []
                this.menuIdFlag = data.menuId
                this.$commonFunc.commonRequest('get', '/system/buttonManage/list/menuId', 'getButtonList', {menuId: this.menuIdFlag})
                .then(res=>{
                    if(res.obj && res.obj.length) {
                        this.buttonDialogVisible = true
                        let arr = []

                        res.obj.forEach(function(o,i) {
                            arr.push({value: o.buttonId, label: o.buttonName})
                        })
                        this.buttons = arr
                        this.getRoleMenuButton(data.menuId)
                    } else {
                        this.$message.info(this.$t('m.menuNoBtn'))
                    }
                })
                .catch(res=>{
                    this.$message.error(res.message)
                })
            }
        },
        //获得角色菜单有的按钮
        getRoleMenuButton() {
            this.checkAll = false
            this.checkedButtons = []
            this.$commonFunc.commonRequest('get', '/system/role/getRoleMenuButton', 'getRoleMenuButton', {menuId: this.menuIdFlag, roleId: this.roleIdFlag})
            .then(res=>{
                if(res.obj && res.obj.length) {
                    let arr = []
                    res.obj.forEach(function(o,i) {
                        arr.push(o.buttonId)
                    })
                    this.checkedButtons = arr
                    this.checkAll = this.checkedButtons.length === this.buttons.length 
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //修改角色菜单有的按钮
        modifyRoleMenuButton() {

            this.$commonFunc.commonRequest('post', '/system/role/updateRoleMenuButton', 'modifyRoleMenuButton', {menuId: this.menuIdFlag, roleId: this.roleIdFlag, buttonIds: this.checkedButtons})
            .then(res=>{
                this.$message.success(this.$t('m.saveSuccess'))
                this.buttonDialogVisible = false
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //获取所有角色
        getRoleList() {
            this.$commonFunc.commonRequest('get', '/system/role/getRoleList', 'getRoleList', this.searchParam)
            .then(res=>{
                this.tableData = res.obj.list
                this.total = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //获得当前角色下拥有的用户列表
        getRoleUser() {
            this.searchParam2.roleId = this.roleIdFlag
            this.$commonFunc.commonRequest('get', '/system/role/getRoleUser', 'getRoleUser', this.searchParam2)
            .then(res=>{
                this.tableData2 = res.obj.list
                this.total2 = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //获得当前角色下未拥有的用户列表
        getRoleNoUser() {
            this.searchParam3.roleId = this.roleIdFlag
            this.$commonFunc.commonRequest('get', '/system/role/getRoleNoUser', 'getRoleNoUser', this.searchParam3)
            .then(res=>{
                this.tableData3 = res.obj.list
                this.total3 = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        viewRole(row) {
            this.$commonFunc.commonRequest('get', '/system/role/getRoleDetail', 'getRoleDetail', {roleId: row.roleId})
            .then(res=>{
                this.form['roleId'] = res.obj.roleId
                this.form['name'] = res.obj.roleName
                this.form['enableFlag'] = res.obj.enableFlag
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addRole() {
            this.$commonFunc.commonRequest('get', '/system/role/verifyRoleName', 'verifyRoleName', this.form)
            .then(res=>{
                if(res.obj) {
                    this.$message.error(this.$t('m.roleNameExist'))
                } else {
                    this.$commonFunc.commonRequest('post', '/system/role/addRole', 'addRole', this.form)
                    .then(res=>{
                        this.$message.success(this.$t('m.addSuccess'))
                        this.addDisable = false
                        this.dialogVisible = false
                        this.getRoleList()
                    })
                    .catch(res=>{
                        this.$message.error(res.message)
                        this.addDisable = false
                    })
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
            
        },
        modifyRole() {
            this.$commonFunc.commonRequest('get', '/system/role/verifyRoleName', 'verifyRoleName', this.form)
            .then(res=>{
                if(res.obj) {
                    this.$message.error(this.$t('m.roleNameExist'))
                } else {
                    this.$commonFunc.commonRequest('post', '/system/role/updateRoleInfo', 'updateRole', this.form)
                    .then(res=>{
                        this.$message.success(this.$t('m.modifySuccess'))
                        this.dialogVisible = false
                        this.getRoleList()
                    })
                    .catch(res=>{
                        this.$message.error(res.message)
                    })
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
            
        },
        getResorceTree() {
            this.$commonFunc.commonRequest('get', '/system/menuManage/list')
            .then(res=>{
                this.treeData = res.obj
                this.getRoleMenu()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //获得当前角色拥有的资源
        getRoleMenu() {
            this.defaultCheckedMenu = []
            this.$commonFunc.commonRequest('get', '/system/role/getRoleMenu', 'getRoleMenu', {roleId: this.roleIdFlag})
            .then(res=>{
                if(res.obj.length) {
                    let menuIds = []
                    res.obj.forEach(function(o,i) {
                       menuIds.push(o.menuId)
                    })
                    this.defaultCheckedMenu = menuIds
                    this.checkStrictly = false
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //新增角色菜单
        addRoleMenu() {
            let menuIds = []
            this.$refs.tree.getCheckedNodes(false, true).forEach(function(item,index){
                menuIds.push(item.menuId)
            })
            let deleteMenuIds = []
            let addMenuIds = []
            let flag = true
            for(let i = 0; i < this.defaultCheckedMenu.length; i++) {
                flag = true
                for(let j = 0; j < menuIds.length; j++) {
                    if(this.defaultCheckedMenu[i] == menuIds[j]) {
                        flag = false
                    }
                }
                if(flag) {
                    deleteMenuIds.push(this.defaultCheckedMenu[i])
                }
            }
            for(let i = 0; i < menuIds.length; i++) {
                flag = true
                for(let j = 0; j < this.defaultCheckedMenu.length; j++) {
                    if(this.defaultCheckedMenu[j] == menuIds[i]) {
                        flag = false
                    }
                }
                if(flag) {
                    addMenuIds.push(menuIds[i])
                }
            }
            this.$commonFunc.commonRequest('post', '/system/role/addRoleMenuRel', 'addRoleMenu', {roleId: this.roleIdFlag, addMenuIds:addMenuIds, deleteMenuIds: deleteMenuIds})
            .then(res=>{
                this.$message.success(this.$t('m.saveSuccess'))
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
            this.operateType = type
            if(type == 'modify') {
                this.showModify = true
                this.viewRole(row)
                this.roleIdFlag = row.roleId
                this.getRoleUser()
                this.getResorceTree()
                this.checkStrictly = true
            } else {
                this.form = {
                    roleId: '',
                    name: '',
                    enableFlag: true
                }
                this.dialogVisible = true
            }
        },
        //检验角色名称是否已经存在
        checkRoleName() {
            this.$commonFunc.commonRequest('get', '/system/role/verifyRoleName', 'verifyRoleName', this.form)
            .then(res=>{
                return res.obj
            })
            .catch(res=>{
                // this.$message.error(res.message)
                return res.message
            })
        },
        //点击选择
        handleChoose() {
            this.chooseDialogVisible = true
            this.getRoleNoUser()
        },
        //弹框保存操作
        haddleSave(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if (type=='add') {
                        this.addDisable = true
                        this.addRole()
                    } else {
                        this.modifyRole()
                    }
                } else {
                    return false;
                }
            });
        },
        handleDelete(type,row) {
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                //单个删除
                if(type == 'single') {
                    this.$commonFunc.commonRequest('post', '/system/role/deleteRole', 'deleteRole', {roleId: row.roleId})
                    .then(res=>{
                        this.$message.success(this.$t('m.deleteSuccess'));
                        this.getRoleList()
                    })
                }
            })
        },
        //用于角色删除关联用户
        handleDelete2(type,row) {
            if( type == 'batch' && this.userIdArr2.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                //单个删除
                if(type == 'single') {
                    this.$commonFunc.commonRequest('post', '/system/role/updateRoleUserRel', 'deleteRoleUser', {roleId: this.roleIdFlag, userId:row.userId,action:'role_user_rel_delete'})
                    .then(res=>{
                        this.$message.success(this.$t('m.deleteSuccess'));
                        this.getRoleUser()
                    })
                //批量删除
                } else {
                    console.log(this.userIdArr2, 529)
                    this.$commonFunc.commonRequest('post', '/system/role/batchUpdateRoleUserRel', 'batchUpdateRoleUser', {roleId: this.roleIdFlag, userIds: this.userIdArr2,action:'role_user_rel_delete'})
                    .then(res=>{
                        this.$message.success(this.$t('m.deleteSuccess'));
                        this.getRoleUser()
                    })
                }
            })
        },
        //处理批量新增用户
        handleBatchAddRoleUser() {
            this.$commonFunc.commonRequest('post', '/system/role/batchUpdateRoleUserRel', 'batchUpdateRoleUser', {roleId: this.roleIdFlag, userIds: this.userIdArr3,action:'role_user_rel_add'})
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.chooseDialogVisible = false
                // this.getRoleNoUser()
                this.getRoleUser()
            })
        },

        //处理单选
        handleSelect2(row) {
            this.userIdArr2 = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.userIdArr2.push(row[i].userId)
                }
            } 
        },
        //处理单选
        handleSelect3(row) {
            this.userIdArr3 = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.userIdArr3.push(row[i].userId)
                }
            } 
        },
    },
    mounted() {
        this.getRoleList()
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/sys/RoleManage.vue